import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend
);

const StatusDistributionChart = ({ delivered = 0, failed = 0, pending = 0, read = 0, other = 0 }) => {
    const total = delivered + failed + pending + read + other;

    // Custom plugin to draw the center text
    const centerTextPlugin = {
        id: 'centerText',
        beforeDraw: function (chart) {
            if (chart.config.type !== 'doughnut') return;

            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;

            ctx.restore();

            // Calculate center position - no horizontal offset
            const textX = Math.floor(width / 2) - 40;
            const textY = Math.floor(height / 2);

            // Font settings for number
            const fontSize = (height / 200).toFixed(2); // Smaller font size
            ctx.font = "bold " + (fontSize * 2.5) + "em sans-serif";
            ctx.textBaseline = "middle";
            ctx.textAlign = "center";
            ctx.fillStyle = "#1f2937"; // text-gray-800
            ctx.fillText(total.toString(), textX, textY - 5);

            // Font settings for "Total" label
            ctx.font = (fontSize + 5) + "em sans-serif";
            ctx.fillStyle = "#6b7280"; // text-gray-500
            ctx.fillText("Total", textX, textY + 35);

            ctx.save();
        }
    };

    // Define chart data
    const chartData = {
        labels: ['Delivered', 'Failed', 'Pending', 'Read', 'Other'],
        datasets: [
            {
                data: [delivered, failed, pending, read, other],
                backgroundColor: [
                    'rgba(16, 185, 129, 0.7)',  // green for delivered
                    'rgba(239, 68, 68, 0.7)',   // red for failed
                    'rgba(245, 158, 11, 0.7)',  // yellow for pending
                    'rgba(59, 130, 246, 0.7)',  // blue for read
                    'rgba(156, 163, 175, 0.7)'  // gray for other
                ],
                borderColor: [
                    'rgb(16, 185, 129)',
                    'rgb(239, 68, 68)',
                    'rgb(245, 158, 11)',
                    'rgb(59, 130, 246)',
                    'rgb(156, 163, 175)'
                ],
                borderWidth: 1
            }
        ]
    };

    // Chart options
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    boxWidth: 15,
                    padding: 15
                }
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const label = context.label || '';
                        const value = context.raw || 0;
                        const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                        const percentage = Math.round((value / total) * 100);
                        return `${label}: ${value} (${percentage}%)`;
                    }
                }
            }
        },
        elements: {
            arc: {
                borderWidth: 1
            }
        },
        cutout: '60%',
        layout: {
            padding: {
                left: 15,
                right: 15
            }
        }
    };

    return (
        <div className="h-full w-full">
            {total === 0 ? (
                <div className="flex items-center justify-center h-full">
                    <p className="text-gray-500">No status data available</p>
                </div>
            ) : (
                <Doughnut
                    data={chartData}
                    options={options}
                    plugins={[centerTextPlugin]}
                />
            )}
        </div>
    );
};

export default StatusDistributionChart; 